import { render, staticRenderFns } from "./leagues.vue?vue&type=template&id=57b05cd9&"
import script from "./leagues.vue?vue&type=script&lang=js&"
export * from "./leagues.vue?vue&type=script&lang=js&"
import style0 from "./leagues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports